import SectionReveal from "@/components/SectionReveal";
import { Activity, Database, Search, ShieldCheck } from "lucide-react";

const steps = [
  { label: "Observe", detail: "Network activity and service health", icon: Activity },
  { label: "Understand", detail: "Authoritative operational state", icon: Database },
  { label: "Recommend", detail: "Context-rich explanation and next step", icon: Search },
  { label: "Govern", detail: "Action within role and policy authority", icon: ShieldCheck },
];

export default function OperationalFlow({ title = "From traffic to intelligence to action." }) {
  return (
    <SectionReveal as="figure" className="lf-operational-flow lf-signal-diagram">
      <figcaption>{title}</figcaption>
      <ol>
        {steps.map(({ label, detail, icon: Icon }, index) => (
          <li key={label}>
            <span className="lf-flow-step">0{index + 1}</span>
            <Icon className="h-5 w-5" strokeWidth={1.6} aria-hidden="true" />
            <strong>{label}</strong>
            <small>{detail}</small>
          </li>
        ))}
      </ol>
    </SectionReveal>
  );
}
